import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Col, VertLink } from '@vertem-core/vertice-ds';
import isExternalLink from 'Utils/isExternalLink';

const MenuLinks = ({ links=[], setOpenModal }) => {
  const targetLink = ( url ) => {
    if (isExternalLink(url)) {
      return '_blank';
    }
    return '_self';
  }
  return (
    <>
      {links.map(({ label=[], path }) => (
        <Col key={path} className="MenuLinks-item padding-x-extra-small">
          {path == 'external-points-cash' ? (
            <a
              className="MenuLinks-item-link"
              onClick={() => setOpenModal(true)}
            >
              {parse(`<span>${label}</span>`)}
            </a>
          ) : (
            <VertLink to={path} className="MenuLinks-item-link" target={targetLink(path)}>
              {parse(`<span>${label}</span>`)}
            </VertLink>
          )}
        </Col>
      ))}
    </>
  );
};

MenuLinks.propTypes = {
  links: PropTypes.array,
};

export default MenuLinks;
